// extracted by mini-css-extract-plugin
module.exports = {"loaderOverlay":"LoaderOverlay_loaderOverlay__g_4Ds","rotation":"LoaderOverlay_rotation__wE0IA"};